module.exports = __webpack_public_path__ + "img/tips.55ffd001.png";